import { render, staticRenderFns } from "./antiDiseaseList.vue?vue&type=template&id=171724e6"
import script from "./antiDiseaseList.vue?vue&type=script&lang=js"
export * from "./antiDiseaseList.vue?vue&type=script&lang=js"
import style0 from "./antiDiseaseList.vue?vue&type=style&index=0&id=171724e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports